import { MaintenanceAppointmentModel } from 'api/models';

export function needsWorkCompletionPrompt(
  appointment: MaintenanceAppointmentModel,
): boolean {
  return (
    !appointment.outcome &&
    appointment.status === 'Scheduled' &&
    !!appointment.scheduledStartOn &&
    new Date(appointment.scheduledStartOn) < new Date()
  );
}
